import $ from 'jquery';
import 'tilt.js';
function StaffMemberScroll() {

    const container = $('.staff-members');
    const column = $('.staff-members__col');
    $('.staff-members__row').scroll( function() {
        container.removeClass('active');
        container.addClass('active');
var newScrollLeft=$('.staff-members__row').scrollLeft();
  if(newScrollLeft===0){
    container.removeClass('active');
  }

    })
    }
  export default {
    init() {
        StaffMemberScroll();
    },
  };
  